<template>
    <v-col cols="12">
        <div class="ma-auto" style="width:fit-content">
            <v-label>How handy would a scanner be for your business?</v-label>
            <v-radio-group inline v-model="form.copier.need_a_scanner">
                <v-radio color="info" label="Not Really" value="Not Really"></v-radio>
                <v-radio color="info" label="Useful" value="Useful"></v-radio>
                <v-radio color="info" label="Very Useful" value="Very Useful"></v-radio>
            </v-radio-group>
        </div>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
